import DeleteRequirementContainer from "./DeleteRequirementContainer";
export default DeleteRequirementContainer;
